import { useSelector } from 'react-redux';

const isNativePlatform = (platform) =>
  platform === 'ios' || platform === 'android';

const isInNativeWebView = () =>
  typeof window !== 'undefined' && !!window.ReactNativeWebView;

const NATIVE_BOTTOM_INSET_MIN = 20;

export function usePlatformInsets() {
  const { platform, statusBarHeight, bottomInset } = useSelector(
    (state) => state.platform
  );

  const isNative = isNativePlatform(platform) || isInNativeWebView();
  const measuredBottomInset = bottomInset || 0;

  return {
    isNative,
    platform,
    statusBarHeight: statusBarHeight || 0,
    measuredBottomInset,
    bottomInset: isNative
      ? Math.max(measuredBottomInset, NATIVE_BOTTOM_INSET_MIN)
      : 0,
  };
}
